<template>
  <section
    class="pt-35 pb-35 "
    :style="{ backgroundColor: `var(--c-${vars.backgroundColor})` }"
  >
    <div class="container">
    
      <div class="row">
        <div class="col-12 text-center mb-5">
          <h5 class="text-white">{{ vars.titleText }}</h5>
        </div>
      </div>

      <div class="row y-gap-30 md:x-gap-10 md:y-gap-10 justify-content-center">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center"
        >
          <a
            :href="item.link"
           
          >
            <div class=" text-center">
           
              <img
  :src="item.image || item.lightimg"
  alt="logo"
/>

              
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { isThrowStatement } from 'typescript';
import { ComponentMixin } from '~/mixins/component.mixin';


export default defineNuxtComponent({
  name: 'BrandBanner',

 

  mixins: [ComponentMixin],

  data() {
    return {
      
    };
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    items() {
      return this.groupedVariables.items;
    },
  },
});
</script>


